// extracted by mini-css-extract-plugin
module.exports = {"About__container":"About__container_1Ijv","About__headline":"About__headline_1lUO","About__content":"About__content_3CWB","About__visual":"About__visual_1i1H"};